import React from 'react';

interface IProps {
  className?: string;
}

export function DatepickerWithCheckmark({ className }: IProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="220"
      height="220"
      viewBox="0 0 220 220"
      className={className}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      >
        <g stroke="#1E3D5A" strokeWidth="3" transform="translate(-911 -5321)">
          <g transform="translate(913 5323)">
            <path d="M0 19.5L216 19.5 216 216 0 216z"></path>
            <path d="M46.5 0L46.5 46.5"></path>
            <path d="M168 0L168 46.5"></path>
            <path d="M0 66L216 66"></path>
            <path d="M154.5 141c0 25.681-20.819 46.5-46.5 46.5S61.5 166.681 61.5 141 82.319 94.5 108 94.5"></path>
            <path d="M88.5 136.289l15.274 11.283c2.008 1.482 4.843 1.156 6.45-.743L154.5 94.5"></path>
          </g>
        </g>
      </g>
    </svg>
  );
}
